import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import { IModal } from "./ICancelModal";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  minWidth: "300px",
};
export default function CancelModals({
  serviceName,
  openCancelModal,
  setOpenCancelModal,
  requestModel,
  response,
  setFinalized,
  setResponseData,
}: IModal) {
  const handleClose = () => setOpenCancelModal(false);
  type MyResponseType = InstanceType<typeof response>;
  const { mutate: cancelMutation } = useMutation(serviceName, {
    onSuccess: (result: MyResponseType) => {
      setResponseData(result);
      handleClose();
      setFinalized(uuid());
    },
  });
  const handelVerify = () => {
    cancelMutation(requestModel!);
  };
  const handelCancel = () => {
    handleClose();
  };

  return (
    <div>
      <Modal
        open={openCancelModal}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            borderRadius: "6px",
            //  padding: "40px 70px 70px 60px"
          }}
          // className="ModalCmp textCenter "
          className="textCenter "
        >
          <div>
            <Typography className="textCenter mTop30 mbottom20">
              آیا از <b className="colorCancel">حذف کردن </b> این درخواست
              اطمینان دارید؟
            </Typography>
          </div>
          <Grid container spacing={2} columns={16} className="mTop20">
            <Grid item xs={8}>
              <Button
                onClick={handelVerify}
                fullWidth
                className="btnForm DangerDefault"
              >
                حذف
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Button
                onClick={handelCancel}
                fullWidth
                className="btnForm ComingBack"
              >
                انصراف
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
